import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { SelectAdoProjects } from './SelectAdoProjectsExtension';

export const SelectAdoProjectsFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'SelectAdoProjects',
    component: SelectAdoProjects,
  }),
);
